import { useState } from "react";
import { Button } from "@/components/ui/button";
import {
  Collapsible,
  CollapsibleContent,
  CollapsibleTrigger,
} from "@/components/ui/collapsible";
import { ChevronDown, ChevronUp } from "lucide-react";

interface RawOcrTextSectionProps {
  text: string | null | undefined;
}

export function RawOcrTextSection({ text }: RawOcrTextSectionProps) {
  const [open, setOpen] = useState(false);

  if (!text) return null;

  return (
    <Collapsible open={open} onOpenChange={setOpen}>
      <CollapsibleTrigger asChild>
        <Button variant="ghost" className="w-full justify-between">
          <span>Raw OCR Text</span>
          {open ? (
            <ChevronUp className="h-4 w-4" />
          ) : (
            <ChevronDown className="h-4 w-4" />
          )}
        </Button>
      </CollapsibleTrigger>
      <CollapsibleContent>
        <div className="p-3 bg-muted rounded-lg max-h-48 overflow-y-auto">
          <pre className="text-xs whitespace-pre-wrap font-mono">{text}</pre>
        </div>
      </CollapsibleContent>
    </Collapsible>
  );
}
